//IMMIGRATION AND CITIZENSHIP

import strs from './../strings';
import { Spacer, DragNDrop, handleUpload, EmptyElement, BackButton, BasicInfoForm, AddressForm, SubmissionArea, DropResult, PDFViewer, Spacer25, ConfirmNewCase, Spacer100, Children, LegalStatus, AuxCompletionProof, Licenses, HaveCompany, ExColony, NumJobs, SignaturePad, NoCasesAvailable, Guardian, Caretaker, ResponsibleDeclarations, CriminalRecordsCheck } from '../Utils';
import { useAutoAnimate } from '@formkit/auto-animate/react';
import { FormContext } from '../context';
import { useInitCase } from './immigration_and_citizenship';
import { DocumentsGridPopup, FullscreenDocument } from '../Popups';
import { useState } from 'react';

const lang = strs.en;

function LoadingDocs() {
	return(
	<div className='animated-div'>
		<Spacer100 />
		<h3 className='secondary-title centered-text '><i>{lang.loadingDocs}</i></h3>
		<Spacer />
		<div className='center-flex logo-loading-rotate'>
			<img className='header__logo' alt="logo" src='/spinningLogo.png' />
		</div>
	</div>
	);
}

export function ArraigoFamiliar(props) {
	const newProps = {
		...props,
		caseType: "arraigoFamiliar"
	}
	console.log('arraigo social');
	const {globalForm, setGlobalForm, iframeDoc, setIframeDoc, isIframe, setIsIframe, docPrepop, docPrepopURLs, setDocPrepopURLs, isLoading, setIsLoading, confirmNewCase, setConfirmNewCase, value, smallChildren, setSmallChildren, numChildren, setNumChildren, passportStamp, setPassportStamp, saveCurCase, incrementChildren, decrementChildren, guardian, setGuardian, caretaker, setCaretaker, signatureImg, setSignatureImg, numOtherDocs, setNumOtherDocs, briefcasePopup, setBriefcasePopup, handleTextAreaChangeOtherDocs} = useInitCase(newProps);
	const [bgchkVisible, setBgchkVisible] = useState(globalForm.responsibleDecs?.bgchkExemption === 'bgchk' ? 'large-margin' : 'hidden');

	function handleClick(url) {
		setIframeDoc(url);
		setIsIframe('pdf-viewer-fullscreen fade-in')
	}


	return  confirmNewCase ? <ConfirmNewCase setConfirmNewCase={setConfirmNewCase} />
		:

	(
	isLoading ? <LoadingDocs /> :

	<div>
		<FormContext.Provider value={value}>
		<BackButton />
		<Spacer />
		<div className='form-div'>
			<h1 className='primary-title'>{lang.arraigoFamiliar}</h1>
			<Spacer />
				<h3 className='tertiary-title'>{lang.fullPassport}</h3>
				<Spacer25 />
				<div className=''>
				<div className='large-margin'>
				<DragNDrop 
					text=<div>{lang.fullPassport}  {<span style={{color: 'red'}}>*</span>}</div>
					doc='fullPassport' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					fileNanoID={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].uuid : false}
					initialFileURL={docPrepopURLs['fullPassport'] ? docPrepopURLs['fullPassport'].url : false}
					saveFunc={saveCurCase}
				/>
				</div>
				</div>

			<Spacer />
			<h3 className='tertiary-title'>{lang.requiredDocs}</h3>
			<div className='large-margin animated-div'>
				<DragNDrop 
					text={lang.fee} 
					doc='fee' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					initialFileURL={docPrepopURLs['fee'] ? docPrepopURLs['fee'].url : false}
					fileNanoID={docPrepopURLs['fee'] ? docPrepopURLs['fee'].uuid : false}
					saveFunc={saveCurCase}
					globalForm={globalForm}
					setGlobalForm={setGlobalForm}
				/>
			</div>
			<Spacer />
			<Spacer25 />
			<CriminalRecordsCheck setBgchkVisible={setBgchkVisible}/>
			<Spacer />
			<div className={bgchkVisible}>
				<DragNDrop 
					text={lang.backgroundCheck} 
					doc='backgroundCheck' 
					setBriefcasePopup={setBriefcasePopup}
					clickCallback={handleClick}
					customStyle='pdf-viewer-small'
					initialFileURL={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].url : false}
					fileNanoID={docPrepopURLs['backgroundCheck'] ? docPrepopURLs['backgroundCheck'].uuid : false}
					saveFunc={saveCurCase}
					globalForm={globalForm}
					setGlobalForm={setGlobalForm}
				/>
			</div>
			
			<Spacer />
			<Guardian guardian={guardian} setGuardian={setGuardian} />
			<Spacer />
			{
				<div className={guardian ? '' : 'hidden'}>
					<div className='animated-div upload-grid'>
						<DragNDrop 
							text=<div>{lang.proofMinorsCitizenship} <span style={{color: 'red'}}>*</span></div>
							doc='proofMinorsCitizenship' 
							clickCallback={handleClick} 
							customStyle='pdf-viewer-small' 
							initialFileURL={docPrepopURLs['proofMinorsCitizenship'] ? docPrepopURLs['proofMinorsCitizenship'].url : false}
							fileNanoID={docPrepopURLs['proofMinorsCitizenship'] ? docPrepopURLs['proofMinorsCitizenship'].uuid : false}
							saveFunc={saveCurCase}
							globalForm={globalForm}
							setGlobalForm={setGlobalForm}
						/>

						<DragNDrop 
							text=<div>{lang.proofCustodyOfMinor} <span style={{color: 'red'}}>*</span></div>
							doc='proofCustodyOfMinor' 
							clickCallback={handleClick} 
							customStyle='pdf-viewer-small' 
							initialFileURL={docPrepopURLs['proofCustodyOfMinor'] ? docPrepopURLs['proofCustodyOfMinor'].url : false}
							fileNanoID={docPrepopURLs['proofCustodyOfMinor'] ? docPrepopURLs['proofCustodyOfMinor'].uuid : false}
							saveFunc={saveCurCase}
							globalForm={globalForm}
							setGlobalForm={setGlobalForm}
						/>
						<DragNDrop 
							text=<div>{lang.proofResidesWithMinor} <span style={{color: 'red'}}>*</span></div>
							doc='proofResidesWithMinor' 
							clickCallback={handleClick} 
							customStyle='pdf-viewer-small' 
							initialFileURL={docPrepopURLs['proofResidesWithMinor'] ? docPrepopURLs['proofResidesWithMinor'].url : false}
							fileNanoID={docPrepopURLs['proofResidesWithMinor'] ? docPrepopURLs['proofResidesWithMinor'].uuid : false}
							saveFunc={saveCurCase}
							globalForm={globalForm}
							setGlobalForm={setGlobalForm}
						/>
						<DragNDrop 
							text=<div>{lang.proofUpToDateGuardian} <span style={{color: 'red'}}>*</span></div>
							doc='proofUpToDateGuardian' 
							clickCallback={handleClick} 
							customStyle='pdf-viewer-small' 
							initialFileURL={docPrepopURLs['proofUpToDateGuardian'] ? docPrepopURLs['proofUpToDateGuardian'].url : false}
							fileNanoID={docPrepopURLs['proofUpToDateGuardian'] ? docPrepopURLs['proofUpToDateGuardian'].uuid : false}
							saveFunc={saveCurCase}
							globalForm={globalForm}
							setGlobalForm={setGlobalForm}
						/>
					</div>
				</div>
			}

			<Caretaker caretaker={caretaker} setCaretaker={setCaretaker} />

			{
				<div className={caretaker ? '' : 'hidden'}>
					<div className='animated-div upload-grid'>
						<DragNDrop 
							text=<div>{lang.proofDisabledCitizenship} <span style={{color: 'red'}}>*</span></div>
							doc='proofDisabledCitizenship' 
							clickCallback={handleClick} 
							customStyle='pdf-viewer-small' 
							initialFileURL={docPrepopURLs['proofDisabledCitizenship'] ? docPrepopURLs['proofDisabledCitizenship'].url : false}
							fileNanoID={docPrepopURLs['proofDisabledCitizenship'] ? docPrepopURLs['proofDisabledCitizenship'].uuid : false}
							saveFunc={saveCurCase}
							globalForm={globalForm}
							setGlobalForm={setGlobalForm}
						/>
						<DragNDrop 
							text=<div>{lang.proofDisabledDisability} <span style={{color: 'red'}}>*</span></div>
							doc='proofDisabledDisability' 
							clickCallback={handleClick} 
							customStyle='pdf-viewer-small' 
							initialFileURL={docPrepopURLs['proofDisabledDisability'] ? docPrepopURLs['proofDisabledDisability'].url : false}
							fileNanoID={docPrepopURLs['proofDisabledDisability'] ? docPrepopURLs['proofDisabledDisability'].uuid : false}
							saveFunc={saveCurCase}
							globalForm={globalForm}
							setGlobalForm={setGlobalForm}
						/>
						<DragNDrop 
							text=<div>{lang.proofLegalCaretaker} <span style={{color: 'red'}}>*</span></div>
							doc='proofLegalCaretaker' 
							clickCallback={handleClick} 
							customStyle='pdf-viewer-small' 
							initialFileURL={docPrepopURLs['proofLegalCaretaker'] ? docPrepopURLs['proofLegalCaretaker'].url : false}
							fileNanoID={docPrepopURLs['proofLegalCaretaker'] ? docPrepopURLs['proofLegalCaretaker'].uuid : false}
							saveFunc={saveCurCase}
							globalForm={globalForm}
							setGlobalForm={setGlobalForm}
						/>
						<DragNDrop 
							text=<div>{lang.proofDisabledInCare} <span style={{color: 'red'}}>*</span></div>
							doc='proofDisabledInCare' 
							clickCallback={handleClick} 
							customStyle='pdf-viewer-small' 
							initialFileURL={docPrepopURLs['proofDisabledInCare'] ? docPrepopURLs['proofDisabledInCare'].url : false}
							fileNanoID={docPrepopURLs['proofDisabledInCare'] ? docPrepopURLs['proofDisabledInCare'].uuid : false}
							saveFunc={saveCurCase}
							globalForm={globalForm}
							setGlobalForm={setGlobalForm}
						/>
						<DragNDrop 
							text=<div>{lang.proofFamilyMembers} <span style={{color: 'red'}}>*</span></div>
							doc='proofFamilyMembers' 
							clickCallback={handleClick} 
							customStyle='pdf-viewer-small' 
							initialFileURL={docPrepopURLs['proofFamilyMembers'] ? docPrepopURLs['proofFamilyMembers'].url : false}
							fileNanoID={docPrepopURLs['proofFamilyMembers'] ? docPrepopURLs['proofFamilyMembers'].uuid : false}
							saveFunc={saveCurCase}
							globalForm={globalForm}
							setGlobalForm={setGlobalForm}
						/>
					</div>
				</div>
			}

		{
			(guardian === false && caretaker === false) && (
				<div>
					<Spacer />
					<div className='centered-text'>
						<h3 className='quad-title'>{lang.guardianCaretakerDisclaimer}</h3>
					</div>
				</div>
			)
		}

			<Spacer />
			<Spacer />

			<h3 className='center-flex secondary-title'>{lang.children}</h3>
		{

		}
			<Children 
				smallChildren={smallChildren}
				setSmallChildren={setSmallChildren}
				setNumChildren={setNumChildren}
			/>
		{
			<div className={`${smallChildren ? '' : 'hidden'}`}>
					<Spacer />
					<p className='p larger-font centered-text'>{lang.oneOrBoth}</p>
			{
				Array.from({length: numChildren}).map((_, i) => (
					<div className={`animated-div two-column-upload-grid`}>
						<DragNDrop 
							text={lang.childSchoolEnrollment + ` ${i+1}`} 
							doc={`childSchoolEnrollment${i+1}`}
							fileNanoID={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childSchoolEnrollment${i+1}`] ? docPrepopURLs[`childSchoolEnrollment${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>

						<DragNDrop 
							text={lang.childCourseCompletion + ` ${i+1}`} 
							doc={`childCourseCompletion${i+1}`}
							fileNanoID={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].uuid : false}
							initialFileURL={docPrepopURLs[`childCourseCompletion${i+1}`] ? docPrepopURLs[`childCourseCompletion${i+1}`].url : false}
							saveFunc={saveCurCase}
						/>

					</div>
				))
			}

			<div className='center-flex'>
				<button className='form-action-btn new-btn' onClick={incrementChildren}>Add child +</button>
				<button className='form-action-btn new-btn' onClick={decrementChildren}>Delete child +</button>
			</div>

			</div>
		}

		{
			<>
			<Spacer100 />
			<h3 className='tertiary-title'>{lang.additionalDocs}</h3>
			<Spacer />
			<p className='larger-font centered-text'>{lang.anyAdditionalDocs}</p>
			<Spacer />

			{
			Array.from({ length: numOtherDocs }).map((_, i) => {
				console.log('message', docPrepopURLs[`other${i+1}`]);
				
				return(
				<div className='large-margin animated-div'>
					<DragNDrop text={lang.other} 
						doc={`other${i+1}`}
						setBriefcasePopup={setBriefcasePopup}
						clickCallback={handleClick} 
						customStyle='pdf-viewer-small' 
						initialFileURL={docPrepopURLs[`other${i+1}`] ? docPrepopURLs[`other${i+1}`].url : false}
						fileNanoID={docPrepopURLs[`other${i+1}`] ? docPrepopURLs[`other${i+1}`].uuid : false}
						saveFunc={saveCurCase}
						msg={docPrepopURLs[`other${i+1}`]?.msg}
					/>
					<Spacer />
					<div className='center-flex'>
					<textarea className='text-area' defaultValue={docPrepopURLs[`other${i+1}`] ? docPrepopURLs[`other${i+1}`].msg : ''} placeholder={lang.optionalMessage} onChange={(e) => handleTextAreaChangeOtherDocs(e, i)}></textarea>
					</div>
					<Spacer />
					<Spacer25 />
				</div>
				);
			})
			}

			<div className='center-flex'>
				<button className='form-action-btn new-btn' onClick={() => {
					setNumOtherDocs(numOtherDocs + 1);
				}}>{lang.addDocument} +</button>
			</div>
			</>
		}

			<Spacer100 />

			<h3 className='center-flex secondary-title'>{lang.basicInfo}</h3>
			<Spacer />
			<p className='centered-text p'>{lang.smartAutoFill}</p>
			<Spacer25 />
			<BasicInfoForm />
			<Spacer />
			<h3 className='center-flex secondary-title'>{lang.physicalAddress}</h3>
			<Spacer />
			<AddressForm />

			<Spacer />
			<ResponsibleDeclarations />
			<Spacer />

			<h3 className='tertiary-title'>{lang.signaturePad}</h3>
			<Spacer25 />
			<p className='p centered-text'>{lang.signatureForm}</p>
			<Spacer />
			<div className='center-flex'>
				<SignaturePad saveFunc={saveCurCase} updateSignatureImg={setSignatureImg} />
			</div>

			<SubmissionArea saveFunc={saveCurCase}/>
	<FullscreenDocument visible={isIframe} closeFunc={setIsIframe} src={iframeDoc} />
	<DocumentsGridPopup onSelect={() => {console.log('onSelect')}} isVisible={briefcasePopup} setIsVisible={setBriefcasePopup}/>


		</div>
		</FormContext.Provider>
	</div>
	)

}

